import { T } from '@/libs/translation';
import { Link, Typo } from '@/ui/component/atom';
import { getSharedData, PostMessage } from '@/ui/util';
import * as Sentry from '@sentry/browser';
import { add, differenceInMilliseconds, type Duration } from 'date-fns';
import { $, html, View } from 'rune-ts';
import klass from './ServicePopup.module.scss';

export interface ServicePopupData {
  uid: string;
  image: string;
  link?: string;
  disable_duration: Duration;
}

export class ServicePopup extends View<ServicePopupData> {
  override template() {
    return html`<div class="${klass.popup}" data-uid="${this.data.uid}">
      ${this.data.link
        ? new Link(
            {
              href: this.data.link,
              label: html`<img src="${this.data.image}" alt="popup_image" />`,
            },
            { target: '_blank', klass: klass.image },
          )
        : html`<div class="${klass.image}">
            <img src="${this.data.image}" alt="popup_image" />
          </div>`}
      <div class="${klass.bottom_bar}">
        ${new Typo(
          { text: T('common.dont_show_again') },
          { typo: 'p2', color: 'white', klass: `${klass.link} dont_show_again` },
        )}
        ${new Typo(
          { text: T('common.close') },
          { typo: 'p2', weight: 'bold', color: 'white', klass: `${klass.link} close` },
        )}
      </div>
    </div> `;
  }

  override onRender() {
    const { app_info } = getSharedData(this);
    this.delegate('click', Link, (e, link) => {
      if (app_info?.name === 'MarppleShop') {
        e.originalEvent.preventDefault();
        PostMessage.goEmptyScreen({ uri: link.data.href });
      }
    });

    this.delegate('click', '.dont_show_again', () => {
      localStorage.setItem(`popup__${this.data.uid}`, JSON.stringify({ ...this.data, created_at: new Date() }));
      ServicePopup.close(this.data.uid);
    });

    this.delegate('click', '.close', () => {
      ServicePopup.close(this.data.uid);
    });
  }

  static close(uid: string) {
    $(document.body).find(`.${ServicePopup}[data-uid="${uid}"]`)?.remove();
  }

  static open(data: ServicePopupData) {
    try {
      const local_data = localStorage.getItem(`popup__${data.uid}`);
      if (local_data) {
        const local_popup_data = JSON.parse(local_data) as ServicePopupData & { created_at: string };
        const enable_popup =
          differenceInMilliseconds(
            add(new Date(local_popup_data.created_at), local_popup_data.disable_duration),
            new Date(),
          ) < 0;

        if (!enable_popup) return;
      }

      document.body.appendChild(new ServicePopup(data).render());
    } catch (e) {
      Sentry.captureException(e, { level: 'error' });
    }
  }
}
